/**
 * Temporary passwords a manager can read out over the phone: two short Polish
 * words without diacritics and three digits, e.g. "komin-lato-482". They must be
 * changed at the next sign-in, and sign-in attempts are rate limited and locked.
 */
const WORDS = [
  'komin', 'dach', 'piec', 'kot', 'las', 'dom', 'most', 'okno',
  'brama', 'lato', 'zima', 'rzeka', 'kawa', 'sowa', 'lis', 'wilk',
  'burza', 'chmura', 'drzewo', 'trawa', 'morze', 'wiatr', 'deszcz', 'sosna',
  'klon', 'buk', 'ryba', 'koza', 'rower', 'auto', 'lampa', 'zegar',
] as const;

/** Uniform random integer in [0, max) from the Web Crypto API (Node 20+ and browsers). */
function randomInt(max: number): number {
  const limit = Math.floor(0x1_0000_0000 / max) * max;
  const buf = new Uint32Array(1);
  for (;;) {
    globalThis.crypto.getRandomValues(buf);
    if (buf[0]! < limit) return buf[0]! % max;
  }
}

export function generateTempPassword(): string {
  const first = WORDS[randomInt(WORDS.length)]!;
  let second: string = WORDS[randomInt(WORDS.length)]!;
  while (second === first) second = WORDS[randomInt(WORDS.length)]!;
  const digits = String(100 + randomInt(900));
  return `${first}-${second}-${digits}`;
}

/** Suggests a login from a full name: "Kamil Wójcik" → "kamil.wojcik". */
export function suggestLogin(fullName: string): string {
  return fullName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ł/g, 'l')
    .replace(/Ł/g, 'L')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '.')
    .replace(/^\.+|\.+$/g, '')
    .slice(0, 32);
}
